import { Link } from 'react-router-dom';
import { articles } from '@/mocks/news';

export default function LatestNews() {
  const latestArticles = articles.slice(0, 4);

  const articleImages: Record<string, string> = {
    '1': 'https://readdy.ai/api/search-image?query=Dramatic%20news%20scene%20with%20warm%20lighting%20and%20mysterious%20atmosphere%2C%20journalism%20concept%2C%20editorial%20photography%2C%20dark%20amber%20and%20charcoal%20tones%2C%20breaking%20news%20mood%2C%20professional%20composition%2C%20soft%20shadows&width=600&height=400&seq=news-card-01&orientation=landscape',
    '2': 'https://readdy.ai/api/search-image?query=Gaming%20streaming%20setup%20in%20darkness%20with%20dramatic%20red%20neon%20lighting%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20warm%20dark%20tones%2C%20professional%20composition%2C%20cinematic%20mood&width=600&height=400&seq=news-card-02&orientation=landscape',
    '3': 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20in%20spotlight%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20composition&width=600&height=400&seq=news-card-03&orientation=landscape',
    '4': 'https://readdy.ai/api/search-image?query=Television%20studio%20stage%20with%20dramatic%20spotlights%2C%20reality%20show%20set%2C%20editorial%20photography%2C%20dark%20atmosphere%2C%20warm%20golden%20tones%2C%20professional%20composition%2C%20theatrical%20mood&width=600&height=400&seq=news-card-04&orientation=landscape',
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            最新爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            每日实时更新，吃瓜追瓜永不错过
          </p>
        </div>

        <div className="overflow-x-auto pb-4 scrollbar-hide">
          <div className="flex gap-5 md:gap-6 min-w-max px-1">
            {latestArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group w-[280px] md:w-[320px] flex-shrink-0 rounded-xl bg-background-50 overflow-hidden hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={articleImages[article.id]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`${article.title} - 黑料在线`}
                  />
                  {idx === 0 && (
                    <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-3 py-1 rounded-full">
                      最新
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 line-clamp-2 mb-2 group-hover:text-accent-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.date}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}